// CMP-0101 · LFS Primitives (Icon, Logo) · Catalog Engine · Lot Discovery · owner: Platform
// 99-1: /Users/yogeshmathur/ym/lot-for-sale-ph/docs/design-handoff/README.md
// 99-1-decision: ADAPT the approved Claude Design Concept D (Header D logo, Material Symbols) onto the existing Spire Next.js app (registry SEL-LFS-001, countersigned)
import Link from "next/link"
import type { CSSProperties } from "react"

export function Icon({ name, size = 22, color, style }: { name: string; size?: number; color?: string; style?: CSSProperties }) {
  return (
    <i className="lfs-icon" aria-hidden="true" style={{ fontSize: size, color, ...style }}>
      {name}
    </i>
  )
}

export function Logo({ dark = false }: { dark?: boolean }) {
  const ink = dark ? "#fff" : "#121722"
  return (
    <Link href="/" aria-label="LOT FOR SALE Philippines — home" style={{ display: "flex", alignItems: "center", gap: 10, color: ink, textDecoration: "none", flexShrink: 0 }}>
      <span style={{ width: 26, height: 26, border: `2.5px solid ${ink}`, borderRadius: 3, position: "relative", display: "block", boxSizing: "border-box" }}>
        <span style={{ position: "absolute", right: 2, bottom: 2, width: 8, height: 8, background: dark ? "#8FB0FF" : "#1A5CF0", borderRadius: 1 }} />
      </span>
      <span style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <span style={{ fontWeight: 700, fontSize: 17, letterSpacing: "-.01em" }}>LOT FOR SALE</span>
        <span style={{ fontSize: 9, letterSpacing: ".3em", fontWeight: 500, color: dark ? "#94a3b8" : "#5E6776", marginTop: 4 }}>PHILIPPINES</span>
      </span>
    </Link>
  )
}
